import { Outlet } from 'react-router-dom'
import { useRoleStore } from '@/store/role.store'
import { useInactivityTimeout } from '@/hooks/useInactivityTimeout'
import { Modal } from '@/components/ui'
import { Button } from '@/components/ui'
import BottomNav from './BottomNav'
import Sidebar from './Sidebar'
import TopBar from './TopBar'

function InactivityGuard() {
  const { showWarning, stayActive } = useInactivityTimeout()
  return (
    <Modal open={showWarning} onClose={stayActive} title="Still there?">
      <div className="space-y-4">
        <p className="text-sm text-[var(--text-muted)]">
          You've been inactive for 14 minutes. For your security, you'll be signed out in 1 minute.
        </p>
        <Button className="w-full" onClick={stayActive}>
          Stay Signed In
        </Button>
      </div>
    </Modal>
  )
}

export default function AppShell() {
  const { activeRole } = useRoleStore()

  return (
    <div data-role={activeRole} className="flex h-screen overflow-hidden bg-[var(--surface)]">
      <aside className="hidden md:flex">
        <Sidebar />
      </aside>

      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 md:py-8">
            <Outlet />
          </div>
        </main>
      </div>

      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50">
        <BottomNav />
      </div>

      <InactivityGuard />
    </div>
  )
}
